// extracted by mini-css-extract-plugin
export default {"title":"order-page_title__1mxAU"};